import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
        >
          <path d="M0 16.714h18V18H0v-1.286zM14.784 8.356l-.906-.91-4.236 4.236V0H8.357v11.682L4.12 7.446l-.904.909L9 14.143l5.784-5.787z"></path>
        </svg>
    );
}